import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { ChordHistoryLabelMode } from "../../models/ChordHistoryOptions.model";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";

interface Props {}
interface State {}

const TITLE = "How to display chords...";
const shortNames = [ChordHistoryLabelMode.RootLetter, ChordHistoryLabelMode.RootDegree];
const descriptions = ["With their root letter, for example Cmaj7 or G7.", "With their scale degree, for example Imaj7 or V7."];

function printShortName(x: ChordHistoryLabelMode): string {
  switch (x) {
    case ChordHistoryLabelMode.RootLetter:
      return "Root Letter";
    case ChordHistoryLabelMode.RootDegree:
      return "Root Scale Degree";
  }
}

export default class ChordLabelModeToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeMode = (labelMode: ChordHistoryLabelMode) => {
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { labelMode } });
  };

  render(): ReactNode {
    const labelMode = this.context.chordHistoryOptions.labelMode;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={labelMode}
        printShortName={printShortName}
        onChange={this.changeMode}
      />
    );
  }
}

ChordLabelModeToggle.contextType = AppContextType;
